import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Utility function to merge Tailwind CSS classes
 * This function combines clsx and tailwind-merge for optimal class handling
 * - clsx: Conditionally constructs className strings
 * - twMerge: Intelligently merges Tailwind classes, handling conflicts
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}